export interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  publishedAt: string;
  imageUrl: string;
  tags: string[];
  viewCount: number;
  commentCount: number;
  isHot: boolean;
  isFeatured: boolean;
}

export type CategorySlug = 'entertainment' | 'gossip' | 'social' | 'exclusive';

export interface CategoryInfo {
  name: string;
  slug: CategorySlug;
  description: string;
  icon: string;
}

export const categories: CategoryInfo[] = [
  { name: '娱乐热点', slug: 'entertainment', description: '最新娱乐资讯与热门话题追踪', icon: 'ri-fire-line' },
  { name: '明星八卦', slug: 'gossip', description: '明星动态、绯闻爆料一网打尽', icon: 'ri-star-line' },
  { name: '社会爆料', slug: 'social', description: '社会事件深度揭秘与讨论', icon: 'ri-alert-line' },
  { name: '独家瓜料', slug: 'exclusive', description: '独家内幕与一手瓜料抢先看', icon: 'ri-key-2-line' },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '当红小生深夜密会神秘女子，酒店共度8小时！实锤照片曝光',
    slug: 'dang-hong-xiao-sheng-shen-ye-mi-hui',
    excerpt: '据知情人士透露，某当红流量小生在上周三深夜被拍到与一名神秘女子共同进入某五星级酒店，直到次日早上才先后离开。照片清晰度极高，粉丝直呼"塌房了"。',
    content: `<p>近日，娱乐圈再爆重磅大瓜。据可靠消息，某当红流量小生在上周三深夜被拍到与一名神秘女子共同进入某五星级酒店。</p>
<p>从曝光的照片来看，该小生头戴棒球帽、黑色口罩，身穿休闲卫衣，显得十分低调。而随行的女子则身穿一袭白色连衣裙，身材高挑，气质出众。两人一前一后进入酒店大堂，随后共同乘坐电梯上楼。</p>
<p>据酒店工作人员透露，两人在大约晚上11点入住，直到次日早上7点左右才先后离开。整个过程持续约8小时。</p>
<p>此事一经曝光，立刻在社交媒体引发轩然大波。该小生的粉丝群体迅速分化：有人表示"艺人也有私生活，请给予尊重"；也有人直呼"塌房了塌房了，我的青春结束了"。</p>
<p>截至目前，该小生及其工作室尚未对此事做出任何回应。我们将持续关注事态发展。</p>
<blockquote><p>业内分析人士指出：在当今社交媒体时代，艺人的私生活越来越难以隐藏。建议艺人和团队建立完善的公关预案机制。</p></blockquote>`,
    category: '明星八卦',
    categorySlug: 'gossip',
    author: '吃瓜小编',
    publishedAt: '2026-08-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20luxury%20hotel%20entrance%20at%20night%20with%20a%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20soft%20shadows%2C%20elegant%20architecture%2C%20dramatic%20mood&width=800&height=500&seq=article-01&orientation=landscape',
    tags: ['塌房', '流量小生', '恋情曝光', '狗仔'],
    viewCount: 128500,
    commentCount: 3856,
    isHot: true,
    isFeatured: true,
  },
  {
    id: 2,
    title: '某知名导演被曝潜规则女演员，录音证据流出！圈内震动',
    slug: 'zhi-ming-dao-yan-qian-gui-ze',
    excerpt: '一段据称是某知名导演与女演员的私下对话录音近日在网上疯传。录音中导演以角色为条件暗示女演员，引发网友强烈谴责。',
    content: `<p>近日，一段据称是某知名导演与女演员的私下对话录音在网络上疯传，内容令人震惊。</p>
<p>录音中，该导演以"给你安排一个重要角色"为诱饵，暗示女演员需要"配合"他的一些"私人要求"。当女演员表示犹豫时，导演又称"这个圈子就是这样，你不愿意有的是人愿意"。</p>
<p>录音曝光后，迅速登上各大平台热搜榜。许多圈内人士也纷纷发声谴责这种行为。知名演员李某在微博发文："这个行业需要被净化，支持受害者勇敢站出来。"</p>
<p>中国电影家协会已发布声明，表示将对此事进行调查，并呼吁业内人士共同维护行业风气。</p>
<blockquote><p>法律专家表示：如果录音内容属实，该导演的行为已涉嫌违法，受害方可通过法律途径维权。</p></blockquote>`,
    category: '社会爆料',
    categorySlug: 'social',
    author: '深度调查组',
    publishedAt: '2026-08-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20film%20set%20scene%20with%20director%20chair%20and%20spotlight%2C%20dark%20moody%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20warm%20amber%20and%20shadow%20contrast%2C%20cinematic%20lighting&width=800&height=500&seq=article-02&orientation=landscape',
    tags: ['潜规则', '导演', '录音曝光', '行业整顿'],
    viewCount: 256800,
    commentCount: 7823,
    isHot: true,
    isFeatured: true,
  },
  {
    id: 3,
    title: '某顶流女星被拍到与圈外男友逛街，疑似已秘密交往两年',
    slug: 'ding-liu-nv-xing-quan-wai-nan-you',
    excerpt: '素有"国民初恋"之称的顶流女星近日被拍到与一名圈外男子在商场甜蜜逛街。据知情人士爆料，两人已秘密交往超过两年。',
    content: `<p>素有"国民初恋"之称的顶流女星近日被热心网友拍到与一名圈外男子在某高端商场甜蜜逛街。</p>
<p>从网友拍摄的照片来看，两人虽然没有牵手，但举止亲密，有说有笑。该男子身穿白色衬衫，气质儒雅，看起来像是金融或法律行业的精英人士。两人在一家甜品店停留了约半小时，期间互动十分甜蜜。</p>
<p>据一位不愿透露姓名的圈内人士爆料："他们其实已经在一起两年多了。男方是她大学同学的哥哥，两人是通过一次聚会认识的。感情一直很稳定，只是女方一直不想公开。"</p>
<p>这一消息让该女星的粉丝群体反应不一。有人送上祝福："只要姐姐幸福就好"；也有人表示难以接受："我需要时间消化"。</p>
<p>该女星的经纪公司在接受采访时表示："艺人的私生活我们不予以评论，感谢大家的关心。"</p>`,
    category: '明星八卦',
    categorySlug: 'gossip',
    author: '吃瓜前线',
    publishedAt: '2026-08-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20couple%20walking%20in%20a%20luxury%20shopping%20mall%2C%20candid%20street%20photography%20style%2C%20warm%20indoor%20lighting%2C%20elegant%20atmosphere%2C%20soft%20focus%2C%20fashionable%20casual%20style&width=800&height=500&seq=article-03&orientation=landscape',
    tags: ['恋情曝光', '顶流女星', '圈外男友', '秘密交往'],
    viewCount: 189200,
    commentCount: 5640,
    isHot: true,
    isFeatured: false,
  },
  {
    id: 4,
    title: '综艺录制现场意外：某艺人从高空坠落，紧急送医！最新情况',
    slug: 'zong-yi-lu-zhi-xian-chang-yi-wai',
    excerpt: '某热门综艺节目录制现场发生意外事故。一名艺人在挑战高空项目时不慎从约3米高处坠落，目前已送往医院救治，节目组已暂停录制。',
    content: `<p>今日下午，某热门综艺节目录制现场突发意外事故，引发广泛关注。</p>
<p>据现场工作人员透露，事发时该艺人正在挑战一个高空项目，需要在约3米高的平台上完成指定动作。然而在尝试过程中，安全绳索疑似出现松动，导致艺人失去平衡后坠落。</p>
<p>事故发生后，现场医护人员第一时间进行了紧急处理，随后将其送往附近的三甲医院进行进一步检查和治疗。</p>
<p>节目组随后发布声明称："我们对此次意外事件深表歉意，已暂停所有录制工作。受伤艺人的生命安全是我们的首要关切，我们将全力配合医院的治疗工作，并对事故原因进行彻底调查。"</p>
<p>该艺人的粉丝后援会也发布公告，呼吁大家保持冷静，共同为艺人祈福。</p>
<blockquote><p>截止发稿前，医院方面尚未公布详细伤情。据知情人士透露，该艺人意识清醒，暂无生命危险。</p></blockquote>`,
    category: '娱乐热点',
    categorySlug: 'entertainment',
    author: '现场直击',
    publishedAt: '2026-08-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20set%20with%20emergency%20medical%20team%20and%20production%20equipment%2C%20dramatic%20lighting%2C%20behind%20the%20scenes%20chaos%2C%20warm%20studio%20lights%2C%20professional%20camera%20setup&width=800&height=500&seq=article-04&orientation=landscape',
    tags: ['综艺事故', '高空坠落', '紧急送医', '录制暂停'],
    viewCount: 312400,
    commentCount: 12450,
    isHot: true,
    isFeatured: true,
  },
  {
    id: 5,
    title: '某知名品牌代言人突然宣布解约！传因合同纠纷对簿公堂',
    slug: 'zhi-ming-pin-pai-dai-yan-ren-jie-yue',
    excerpt: '某国际知名品牌今日突然宣布与其中国区代言人——某一线男星解除合约关系。坊间传闻双方因代言费分成问题产生严重分歧，或将进入法律程序。',
    content: `<p>今日上午，某国际知名品牌通过官方微博突然宣布，与其中国区代言人——某一线男星解除合约关系，即日起生效。</p>
<p>品牌方在声明中称："经过双方友好协商，决定终止合作关系。感谢（艺人姓名）过去两年为品牌所做的贡献，祝愿他未来事业顺利。"</p>
<p>然而，据多位业内人士透露，所谓的"友好协商"可能并不那么友好。一位接近该男星团队的消息人士表示："实际上是因为品牌方在去年的一份续约协议中大幅压缩了代言费分成比例，艺人方面认为这是对之前承诺的严重违背。"</p>
<p>更有传闻称，双方可能已经进入了法律程序，一场违约诉讼即将展开。</p>
<p>目前，该男星方面尚未对解约发表任何个人声明。其工作室仅表示"一切以合同条款为准，不便透露更多细节"。</p>
<blockquote><p>品牌代言领域律师分析：明星代言合同中，代言费结构、使用范围、竞品限制等条款往往是争议高发区，建议双方在签约前就明确各项细节。</p></blockquote>`,
    category: '娱乐热点',
    categorySlug: 'entertainment',
    author: '商业观察',
    publishedAt: '2026-08-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20brand%20billboard%20being%20taken%20down%20in%20a%20city%20street%2C%20dramatic%20urban%20scene%2C%20warm%20city%20lighting%2C%20professional%20commercial%20photography%20style%2C%20clean%20composition&width=800&height=500&seq=article-05&orientation=landscape',
    tags: ['代言解约', '合同纠纷', '品牌代言', '违约诉讼'],
    viewCount: 145600,
    commentCount: 4320,
    isHot: true,
    isFeatured: false,
  },
  {
    id: 6,
    title: '独家：某选秀节目黑幕曝光！投票数据被指大规模造假',
    slug: 'xuan-xiu-jie-mu-hei-mu-bao-guang',
    excerpt: '本网独家获得一份内部文件，直指某当红选秀节目的投票系统存在严重造假行为。数据显示大量票数来自虚假账号，前三名中至少有两人的票数被人为操纵。',
    content: `<p>本网独家获得一份来自某当红选秀节目内部的机密文件，直指该节目的线上投票系统存在大规模数据造假行为。</p>
<p>文件显示，在最近一季的比赛中，系统后台检测到大量票数来自通过机器注册的虚假账号。数据显示，至少有超过30%的投票账号存在异常行为，包括极短的注册时间、相同的IP地址段、以及统一的投票时间模式。</p>
<p>更令人震惊的是，根据文件中的分析数据，在目前排名前三的选手中，至少有两人的总票数被人为操纵。文件中的一段内部聊天记录显示，一名工作人员写道："这个数据太假了，我们都不敢公布原始数据。"</p>
<p>此事一经曝光，立即引发了广大观众和参赛选手粉丝的强烈不满。许多为选手投入真金白银投票的粉丝表示"感觉被欺骗了"。</p>
<p>该选秀节目的制作方目前尚未对此事做出回应。但据业内人士透露，相关主管部门已经介入调查。</p>
<blockquote><p>消费者权益保护专家表示：如果投票涉及付费，制作方的造假行为可能构成消费欺诈，受害消费者有权要求退款和赔偿。</p></blockquote>`,
    category: '独家瓜料',
    categorySlug: 'exclusive',
    author: '调查记者',
    publishedAt: '2026-07-31',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20voting%20data%20room%20with%20glowing%20screens%20showing%20numbers%20and%20charts%2C%20investigative%20journalism%20mood%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20digital%20data%20visualization&width=800&height=500&seq=article-06&orientation=landscape',
    tags: ['选秀节目', '投票造假', '独家爆料', '消费欺诈'],
    viewCount: 423100,
    commentCount: 18920,
    isHot: true,
    isFeatured: true,
  },
  {
    id: 7,
    title: '明星夫妇被曝已分居半年，社交账号互相取关实锤',
    slug: 'ming-xing-fu-fu-fen-ju-ban-nian',
    excerpt: '曾经被奉为"娱乐圈模范夫妻"的某明星夫妇近日被曝已分居半年。细心的网友发现两人社交账号已互相取关，且在最近半年的公开场合中从未合体亮相。',
    content: `<p>曾经被奉为"娱乐圈模范夫妻"的某明星夫妇近日被曝出婚姻危机。</p>
<p>据一位与两人都相熟的娱乐圈人士透露，这对明星夫妇实际上已经分居超过半年。该人士称："他们之间的感情问题其实从去年就开始了。主要是因为两人的事业发展方向产生了分歧，一个想继续深耕国内市场，另一个则想进军好莱坞。"</p>
<p>细心的网友也发现了诸多蛛丝马迹：两人的社交媒体账号已经互相取关；在最近半年的所有公开场合中，两人从未合体亮相；甚至连对方生日时也没有在社交平台上送出祝福——而此前每年都会公开秀恩爱。</p>
<p>更有网友扒出，两人名下的多家公司已经在悄悄进行股权变更，疑似在进行财产分割。</p>
<p>截至目前，两人的经纪团队均未对此做出回应，保持沉默的态度似乎从侧面印证了传闻的真实性。</p>
<blockquote><p>婚姻专家分析：明星夫妻面临的不仅是普通婚姻中的问题，还有来自事业、舆论和商业利益的巨大压力，维系婚姻需要更多智慧和努力。</p></blockquote>`,
    category: '明星八卦',
    categorySlug: 'gossip',
    author: '八卦侦探',
    publishedAt: '2026-07-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20split%20screen%20of%20two%20celebrities%20walking%20separately%20in%20different%20directions%2C%20emotional%20distance%20concept%2C%20warm%20but%20melancholic%20lighting%2C%20editorial%20photography%20style&width=800&height=500&seq=article-07&orientation=landscape',
    tags: ['明星夫妻', '分居', '取关', '婚姻危机'],
    viewCount: 267300,
    commentCount: 9876,
    isHot: true,
    isFeatured: false,
  },
  {
    id: 8,
    title: '某平台主播涉嫌逃税被查，涉及金额或超5000万！',
    slug: 'ping-tai-zhu-bo-tao-shui-bei-cha',
    excerpt: '税务局近期对直播行业展开大规模税务稽查。知情人透露某头部平台的多名高收入主播涉嫌通过"阴阳合同"等方式逃避个人所得税，涉及总金额可能超过5000万元。',
    content: `<p>据税务系统内部消息，近期全国各地税务局正在对直播行业展开大规模的税务稽查行动。</p>
<p>本次稽查的重点是直播平台的高收入主播群体。据了解，一些头部主播的年收入可达数千万元，但在申报个人所得税时存在严重问题。</p>
<p>一位知情人士透露："目前被调查的某平台中，有多名主播涉嫌通过'阴阳合同'、虚假工作室报销、以及将个人收入伪造成企业收入等方式逃避个人所得税。初步估算，涉及的总金额可能超过5000万元。"</p>
<p>税务部门已向涉事主播发出了《税务检查通知书》，要求其提供近年来的收入明细和相关合同文件。</p>
<p>此消息一出，直播行业人人自危。多位知名主播连夜下播，并在社交媒体上删除了大量炫耀奢侈生活的视频和照片。</p>
<blockquote><p>税务律师指出：根据《中华人民共和国税收征收管理法》，故意逃避缴纳税款情节严重的，除补缴税款和滞纳金外，还可能面临刑事处罚。</p></blockquote>`,
    category: '社会爆料',
    categorySlug: 'social',
    author: '财经调查',
    publishedAt: '2026-07-29',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxurious%20live%20streaming%20studio%20with%20professional%20equipment%20and%20golden%20decor%2C%20contrast%20between%20wealth%20and%20investigation%2C%20dramatic%20lighting%2C%20editorial%20photography&width=800&height=500&seq=article-08&orientation=landscape',
    tags: ['逃税', '主播', '税务稽查', '阴阳合同'],
    viewCount: 356700,
    commentCount: 15320,
    isHot: true,
    isFeatured: false,
  },
  {
    id: 9,
    title: '某热播剧女主被曝片场耍大牌，全组工作人员苦不堪言',
    slug: 're-bo-ju-nv-zhu-shua-da-pai',
    excerpt: '某正在热播的古装剧女主被剧组工作人员匿名爆料，称其在片场频繁迟到、挑剔伙食、对工作人员态度恶劣。该爆料引发网友对该剧女主角人设的质疑。',
    content: `<p>某正在热播的古装剧近日因女主角的"戏外表现"再次成为舆论焦点。</p>
<p>一位自称是该剧剧组工作人员的匿名人士在网上发布了一篇长文，详细描述了该剧女主角在拍摄期间的种种"耍大牌"行为。</p>
<p>据该工作人员描述，该女主在长达三个月的拍摄期间，迟到早退现象十分严重，最严重的一次让全组等了四个小时。此外，她还对剧组的盒饭挑三拣四，要求剧组为其单独订购高档餐厅的外卖。对普通工作人员的态度也非常傲慢，曾当众训斥一名化妆助理长达十分钟。</p>
<p>这篇爆料文章迅速在网上引发热议。不少网友表示："原来'人美心善'都是人设，太失望了。"也有人认为："不能只听一面之词，应该等当事人的回应。"</p>
<p>目前，该女演员和剧组方面均未对此事做出回应。但值得注意的是，该剧在豆瓣的评分在爆料后出现了明显下滑。</p>`,
    category: '娱乐热点',
    categorySlug: 'entertainment',
    author: '剧组观察',
    publishedAt: '2026-07-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20traditional%20Chinese%20costume%20drama%20film%20set%20with%20ancient%20architecture%2C%20behind%20the%20scenes%20chaos%2C%20warm%20sunset%20lighting%2C%20cinematic%20composition%2C%20production%20crew%20working&width=800&height=500&seq=article-09&orientation=landscape',
    tags: ['耍大牌', '古装剧', '片场爆料', '人设崩塌'],
    viewCount: 198400,
    commentCount: 6720,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 10,
    title: '独家：某国际电影节内定获奖名单提前泄露？',
    slug: 'guo-ji-dian-ying-jie-nei-ding-ming-dan',
    excerpt: '本网独家获取了一份标注为"机密"的文件，疑似某国际电影节的获奖名单。多位业内人士在看过文件后表示"与预期完全吻合"，疑为提前内定。',
    content: `<p>距离某国际电影节颁奖典礼还有不到一周时间，本网独家获取了一份标注为"机密"的内部文件，疑似为本届电影节的完整获奖名单。</p>
<p>这份文件详细列出了包括最佳影片、最佳导演、最佳男女主角在内的所有主要奖项的获奖者。多位业内资深人士在看过文件后表示，这份名单"与他们在圈内听到的风声完全吻合"。</p>
<p>更值得注意的是，名单中多个重要奖项的获得者似乎存在"论资排辈"的嫌疑，而非完全基于作品质量。例如，最佳导演奖的获得者今年并没有特别出彩的作品，但在业内德高望重，"该轮到他了"。</p>
<p>如果这份名单被证实为真，将对该电影节的公信力造成严重冲击。有电影评论人表示："如果评奖变成了'轮流坐庄'，那电影节就失去了其存在的意义。"</p>
<p>电影节组委会尚未对此事做出回应。颁奖典礼将于下周如期举行，届时将揭晓真正的获奖名单。</p>
<blockquote><p>电影学院教授评论：电影评奖应当回归艺术本身。任何形式的"潜规则"都是对电影艺术的伤害和对观众的不尊重。</p></blockquote>`,
    category: '独家瓜料',
    categorySlug: 'exclusive',
    author: '独家线人',
    publishedAt: '2026-07-27',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20prestigious%20film%20festival%20award%20ceremony%20stage%20with%20golden%20trophies%20and%20red%20carpet%2C%20dramatic%20spotlight%2C%20glamorous%20atmosphere%2C%20mysterious%20backstage%20vibe&width=800&height=500&seq=article-10&orientation=landscape',
    tags: ['电影节', '内定名单', '独家爆料', '公信力危机'],
    viewCount: 387200,
    commentCount: 14230,
    isHot: true,
    isFeatured: true,
  },
  {
    id: 11,
    title: '某男团成员被拍到夜店狂欢至凌晨，违反公司禁令',
    slug: 'nan-tuan-cheng-yuan-ye-dian-kuang-huan',
    excerpt: '某当红男团成员近日被拍到在北京某知名夜店狂欢至凌晨4点。由于该男团所属经纪公司明确规定练习生和出道成员不得出入夜店，此事可能面临严厉处罚。',
    content: `<p>近日，某当红男团的一名成员被热心网友拍到在北京三里屯某知名夜店狂欢至凌晨4点。</p>
<p>根据目击者描述和现场照片，该成员当晚与数名友人在夜店VIP包厢内喝酒跳舞，状态十分放松。直到凌晨4点夜店即将打烊时才离开，离开时步伐已经有些不稳，疑似饮酒过量。</p>
<p>此事之所以引发关注，是因为该男团所属经纪公司对旗下艺人有严格的"禁足令"，明确禁止练习生和出道成员出入夜店、酒吧等场所。违反者将面临包括暂停活动、扣减分成、甚至直接解约在内的处罚。</p>
<p>该成员的行为不仅违反了公司规定，也让一直支持他的粉丝感到失望。有粉丝在超话中写道："我们每天熬夜为你打榜做数据，你却在外边花天酒地？"</p>
<p>目前，该经纪公司尚未就是否会对该成员进行处罚发布正式声明。</p>`,
    category: '明星八卦',
    categorySlug: 'gossip',
    author: '夜店蹲点',
    publishedAt: '2026-07-26',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20vibrant%20nightclub%20interior%20with%20colorful%20neon%20lights%20and%20crowded%20dance%20floor%2C%20candid%20nightlife%20photography%2C%20warm%20dim%20lighting%2C%20energetic%20party%20atmosphere&width=800&height=500&seq=article-11&orientation=landscape',
    tags: ['男团', '夜店', '违反禁令', '公司处罚'],
    viewCount: 234500,
    commentCount: 8450,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 12,
    title: '震惊！某慈善基金会善款去向不明，明星发起人被约谈',
    slug: 'ci-shan-ji-jin-hui-shan-kuan-qu-xiang',
    excerpt: '某由多位明星联合发起的慈善基金会近日被曝出账目混乱，超2000万元善款去向不明。民政部门已约谈相关负责人，多名明星发起人为撇清关系紧急发布声明。',
    content: `<p>近日，某由多位知名明星联合发起的慈善基金会陷入严重的财务丑闻。</p>
<p>据审计部门初步调查，该基金会近三年收到的捐款中，有超过2000万元的善款存在账目不清、去向不明的情况。部分款项被转入多个与慈善项目无关的个人账户，另有部分支出缺乏有效的票据和凭证。</p>
<p>此事被媒体曝光后，民政部门迅速介入调查，并对该基金会的法定代表人及主要管理人员进行了约谈。</p>
<p>值得注意的是，该基金会的发起人名单中包括多位一线明星。丑闻爆发后，这些明星纷纷在社交媒体上发布声明，声称自己只是"挂名发起人"，并未参与基金会的日常管理和资金运作，试图与事件撇清关系。</p>
<p>然而，法律专家指出，根据《中华人民共和国慈善法》，基金会发起人和理事对基金会的合规运营负有法定监督责任，"挂名"并不能完全免责。</p>
<blockquote><p>慈善业内人士呼吁：明星参与慈善值得鼓励，但不能只挂名不理事。真正的慈善需要投入时间和精力去关注每一笔善款的去向。</p></blockquote>`,
    category: '社会爆料',
    categorySlug: 'social',
    author: '公益观察',
    publishedAt: '2026-07-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20charity%20foundation%20office%20with%20financial%20documents%20and%20certificates%20on%20wall%2C%20investigative%20mood%2C%20warm%20office%20lighting%2C%20professional%20documentary%20style%2C%20serious%20atmosphere&width=800&height=500&seq=article-12&orientation=landscape',
    tags: ['慈善基金', '善款去向', '明星发起人', '民政约谈'],
    viewCount: 298600,
    commentCount: 11230,
    isHot: false,
    isFeatured: false,
  },
];

export function getArticleById(id: number): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.categorySlug === slug);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.isFeatured);
}

export function getLatestArticles(limit: number = 8): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, limit);
}

export function getRelatedArticles(currentId: number, categorySlug: string, limit: number = 3): Article[] {
  return articles
    .filter((a) => a.id !== currentId && a.categorySlug === categorySlug)
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, limit);
}